import type { Action } from '@ngrx/store';
import type { Axis, ComparisonState } from './buildings-comparison.state';
import type { BuildingsComparisonStoreState } from './index';

export enum ActionType {
    LOAD_STATE = '[BUILDINGS_COMPARISON] LOAD_STATE',
    RESET = '[BUILDINGS_COMPARISON] RESET',
    SET_COMPARISON = '[BUILDINGS_COMPARISON] SET_COMPARISON',
    SET_COMPARISON_AXIS = '[BUILDINGS_COMPARISON] SET_COMPARISON_AXIS',
    SET_PERIOD = '[BUILDINGS_COMPARISON] SET_PERIOD',
    SET_RANKING_INDICATOR = '[BUILDINGS_COMPARISON] SET_RANKING_INDICATOR',
    SET_AVERAGE_ABSCISSA = '[BUILDINGS_COMPARISON] SET_AVERAGE_ABSCISSA',
    SET_AVERAGE_ORDINATE = '[BUILDINGS_COMPARISON] SET_AVERAGE_ORDINATE',
    SET_LINEAR_REGRESSION = '[BUILDINGS_COMPARISON] SET_LINEAR_REGRESSION',
    SET_COMPARISON_X_AXIS = '[BUILDINGS_COMPARISON] SET_COMPARISON_X_AXIS',
    SET_COMPARISON_Y_AXIS = '[BUILDINGS_COMPARISON] SET_COMPARISON_Y_AXIS'
}

export class LoadState implements Action {
    readonly type = ActionType.LOAD_STATE;
    constructor(readonly payload: { state: BuildingsComparisonStoreState.State }) {}
}

export class Reset implements Action {
    readonly type = ActionType.RESET;
}

export class SetComparison implements Action {
    readonly type = ActionType.SET_COMPARISON;
    constructor(readonly payload: { comparison: Partial<ComparisonState> }) {}
}

export class SetComparisonAxis implements Action {
    readonly type = ActionType.SET_COMPARISON_AXIS;
    constructor(readonly payload: { xAxis: Axis; yAxis: Axis }) {}
}

export class SetComparisonXAxis implements Action {
    readonly type = ActionType.SET_COMPARISON_X_AXIS;
    constructor(readonly payload: { axis: Axis }) {}
}

export class SetComparisonYAxis implements Action {
    readonly type = ActionType.SET_COMPARISON_Y_AXIS;
    constructor(readonly payload: { axis: Axis }) {}
}

export class SetPeriod implements Action {
    readonly type = ActionType.SET_PERIOD;
    constructor(readonly payload: { year: number }) {}
}

export class SetRankingIndicator implements Action {
    readonly type = ActionType.SET_RANKING_INDICATOR;
    constructor(readonly payload: { axis: Axis }) {}
}

export class SetAverageAbscissa implements Action {
    readonly type = ActionType.SET_AVERAGE_ABSCISSA;
    constructor(readonly payload: { value: boolean }) {}
}

export class SetAverageOrdinate implements Action {
    readonly type = ActionType.SET_AVERAGE_ORDINATE;
    constructor(readonly payload: { value: boolean }) {}
}

export class SetLinearRegression implements Action {
    readonly type = ActionType.SET_LINEAR_REGRESSION;
    constructor(readonly payload: { value: boolean }) {}
}

export type Actions =
    | LoadState
    | Reset
    | SetComparison
    | SetComparisonAxis
    | SetPeriod
    | SetRankingIndicator
    | SetAverageAbscissa
    | SetAverageOrdinate
    | SetLinearRegression
    | SetComparisonXAxis
    | SetComparisonYAxis;
